import React from "react";

import { makeStyles, createStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) =>
    createStyles({
        text: {
            display: "block",
            height: 0,
            margin: theme.spacing(0, 0, 0, -1.5),
            overflow: "hidden",
            width: 0,
            [theme.breakpoints.up("sm")]: {
                display: "unset",
                height: "unset",
                margin: "unset",
                overflow: "unset",
                width: "unset",
            },
        },
    })
);

export default function HideTextForSmall(props) {
    const classes = useStyles();
    return <span className={classes.text}>{props.children}</span>;
}
